module.exports = __webpack_public_path__ + "static/media/d1.8d5e37ab.svg";